import React, { useEffect, useState } from "react";
import axios from "axios";
// import MainLogo from "../../../src/assets/image/main-logo.png";
import { useLocation } from "react-router-dom";
import Footer from "../footer/Footer";
import { useNavigate } from "react-router-dom";
import Dropdown from "react-bootstrap/Dropdown";
import Button from "react-bootstrap/Button";
import Select from "react-select";
import moment from "moment";
import MainLogo from "../../../assets/image/jgc_logo.png";
import { Spinner, Container, Row, Col } from "react-bootstrap";
import { message } from "antd";
import FormatChecker from "../../Service/FormatChecker";
import Header from "../dashboard/Header";
import { FaCheck } from "react-icons/fa";

// import DatePickers from "..//../ /common/DatePickers";
// import DateTimerPicker from "../common/DateTimerPicker";
import "../../HtmlMainPage/bodycs.css"; // Custom CSS for rotation
import useFetchData from "../../../common/useFetchData";
import CommonFileUploader from "../../../common/CommonFileUploader";
const formatDateTime = (date) => {
    return new Date(date).toLocaleString('en-US', {
        month: 'short',
        day: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true,
    });
};
// const isDateInRange = (date) => {
//   const startDate = new Date("2024-07-029T00:00:00");
//   const endDate = new Date("2024-08-04T23:59:59");
//   const givenDate = new Date(date);

//   return givenDate >= startDate && givenDate <= endDate;
// };

function formatISODate(isoDate) {
    const formattedDate = new Date(isoDate).toLocaleDateString('en-GB', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
    });
    return formattedDate;
}

const isDateInRange = (date) => {
    console.log('data', date)
    const startDate = new Date(process.env.REACT_APP_START_DATE); // Corrected date
    const endDate = new Date(process.env.REACT_APP_END_DATE);
    const givenDate = new Date(date);

    return givenDate >= startDate && givenDate <= endDate;
};
const EditBuyerForm = () => {
    // Get the query parameters from the URL
    const location = useLocation();

    // Function to get query parameter value
    const getQueryParam = (name) => {
        const urlParams = new URLSearchParams(location.search);
        return urlParams.get(name);
    };

    // Get the barcode from the URL
    const barcode = getQueryParam('barcode');


    const [formStatus, setFormStatus] = useState(false);
    const { showData, error } = useFetchData();


    const navigate = useNavigate();

    let currentLocation = useLocation().pathname;

    const designationArray = ["Owner", "Representative"];

    const travelArray = ["Train", "Flight", "Self"];
    const travel_type_Array = ["Arrival", "Departure"];

    const visitingAsArray = [
        "Wholesaler",
        "Manufacturer",
        "Retailer",
        "Chain Store   ",
        "Agent/Broker",
    ];
    const [visitorName, setVisitorName] = useState();
    const [designation, setDesignation] = useState("");

    const [visiting_as, setVisiting_as] = useState("");
    const [yourCompany, setYourCompany] = useState();

    const [companyName, setCompanyName] = useState("");
    const [email, setEmail] = useState();
    const [postalCode, setPostalCode] = useState("");
    const [city, setCity] = useState("");
    const [state, setState] = useState("");
    const [streetAddress, setStreetAddress] = useState("");
    const [country, setCountry] = useState(null);
    const [hearAbout, setHearAbout] = useState("");
    const [photo, setPhoto] = useState();
    const [idProofFront, setIDProofFront] = useState();
    const [idProofBack, setIDProofBack] = useState();
    const [allreadyphoto, setallreadyPhoto] = useState();
    const [allreadyidProofFront, setallreadyIDProofFront] = useState();
    const [allreadyidProofBack, setallreadyIDProofBack] = useState();
    const [gst_number, setGst_number] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [previews, setPreviews] = useState({
        photo: null,
        idProofFront: null,
        idProofBack: null,
        ticket: null
    });
    const [photoStatus, setPhotoStatus] = useState(false);
    const [idFrontStatus, setIdFrontStatus] = useState(false);
    const [idBackStatus, setIdBackStatus] = useState(false);
    const [emailError, setEmailError] = useState("");
    const [arrivalFrom, setArrivalFrom] = useState("");
    const [arrivalDate, setArrivalDate] = useState("");
    const [arrivalTime, setArrivalTime] = useState("");
    const [arrivalMode, setArrivalMode] = useState("");
    const [modeDetails, setModeDetails] = useState("");
    const [ticket, setTicket] = useState(null);
    const [stayDuration, setStayDuration] = useState("");
    const [hotelCheckInDate, setHotelCheckInDate] = useState("");
    const [hotelCheckOutDate, setHotelCheckOutDate] = useState("");
    const [requiresCab, setRequiresCab] = useState("");
    const [departureDate, setDepartureDate] = useState("");
    const [departureTime, setDepartureTime] = useState("");
    const [departureMode, setDepartureMode] = useState("");
    const [allreadyticket, setAllreadyTicket] = useState("");
    const [stayOption, setStayOption] = useState("");

    const [selectedOption, setSelectedOption] = useState("");
    const [showError, setShowError] = useState("");

    const [return_transport_name, setReturn_transport_name] = useState("");
    const [return_train_number, setReturn_train_number] = useState("");
    const [redirectToAddOn, setRedirectToAddOn] = useState(false);
    const [number, setNumber] = useState("");
    const [otp, setOtp] = useState("");
    const [isOtpStep, setIsOtpStep] = useState(false);
    const [isRotated, setIsRotated] = useState(false);
    const [dataPresent, setDataPresent] = useState({});
    const [city_prefered, setCity_prefered] = useState(null);
    const [reload, setReload] = useState(false)
    const [isThankYouPage, setIsThankYouPage] = useState(false)

    const [exhibitorList, setExhibitorList] = useState([]);
    const [exhibitor_one, setExhibitor_one] = useState("");
    const [exhibitor_two, setExhibitor_two] = useState("");
    const [invited_exhibitor_id, setInvited_exhibitor_id] = useState("");
    const [commAddress, setCommAddress] = useState("");
    const [commCity, setCommCity] = useState("");
    const [commPincode, setCommPincode] = useState("");
    const [commState, setCommState] = useState("");
    const [sameAddress, setSameAddress] = useState(false);

    useEffect(() => {
        axios
            .get(`${process.env.REACT_APP_API_END_POINT}/exhibitor-lists-data`)
            .then((resData) => {
                if (resData.data && resData.data.data) {
                    setExhibitorList(resData.data.data);
                }
            })
            .catch((error) => {
                console.error("Error fetching exhibitor list:", error);
            });
    }, []);

    const [date, setDate] = useState('');
    const [time, setTime] = useState('');
    const [mergedDateTime, setMergedDateTime] = useState('');
    const [buyer_edit, setbuyer_edit] = useState(null)

    useEffect(() => {
        console.log('hello', barcode)
        axios.get(`${process.env.REACT_APP_API_END_POINT}/visitor-detail-by-barcode/${barcode}`).then((resData) => {
            console.log('hello', resData.data.data)
            setVisitorName(resData.data.data.visitor_name)
            setNumber(resData.data.data.mobile_number)
            setSelectedOption(resData?.data?.data?.travel_detail?.travel_type)
            setDate(resData?.data?.data?.travel_detail?.arrival_date_time)
            setTime(resData?.data?.data?.travel_detail?.departure_date_time)
            setbuyer_edit(resData?.data?.data)

            // Populate additional fields
            setCompanyName(resData.data.data.company_name || "");
            setGst_number(resData.data.data.gst_number || "");
            setEmail(resData.data.data.email || "");
            setStreetAddress(resData.data.data.street_address || "");
            setCity(resData.data.data.city || "");
            setState(resData.data.data.state || "");
            setPostalCode(resData.data.data.postal_code || "");
            setCountry(resData.data.data.country || "");
            setExhibitor_one(resData.data.data.exhibitor_one || "");
            setExhibitor_two(resData.data.data.exhibitor_two || "");
            setInvited_exhibitor_id(resData.data.data.invited_exhibitor_id || "");
            setCommAddress(resData.data.data.commAddress || "");
            setCommCity(resData.data.data.commCity || "");
            setCommPincode(resData.data.data.commPincode || "");
            setCommState(resData.data.data.commState || "");
            setSameAddress(resData.data.data.sameAddress || false);
            setDesignation(resData.data.data.designation || "");
            setallreadyPhoto(resData.data.data.photo || null);
            setallreadyIDProofFront(resData.data.data.id_proof_front || null);
            setallreadyIDProofBack(resData.data.data.id_proof_back || null);
            
            // Travel Fields
            setArrivalFrom(resData.data.data.arrivalFrom || "");
            setArrivalDate(resData.data.data.arrivalDate || "");
            setArrivalTime(resData.data.data.arrivalTime || "");
            setArrivalMode(resData.data.data.arrivalMode || "");
            setModeDetails(resData.data.data.modeDetails || "");
            const loadedStayDuration1 = resData.data.data.stayDuration || "";
            setStayDuration(loadedStayDuration1);
            if (["2nd July", "3rd July", "4th July", "5th July"].includes(loadedStayDuration1)) {
                setStayOption("1");
            } else if (["2nd - 4th July", "3rd - 5th July", "4th - 6th July", "5th - 6th July"].includes(loadedStayDuration1)) {
                setStayOption("2");
            } else {
                setStayOption("");
            }
            setHotelCheckInDate(resData.data.data.hotelCheckInDate || "");
            setHotelCheckOutDate(resData.data.data.hotelCheckOutDate || "");
            setRequiresCab(resData.data.data.requiresCab || "");
            setDepartureDate(resData.data.data.departureDate || "");
            setDepartureTime(resData.data.data.departureTime || "");
            setDepartureMode(resData.data.data.departureMode || "");
            setAllreadyTicket(resData.data.data.upload_ticket || null);
        })
    }, [barcode])
    const handleMobileNoChange = (e) => {
        const input = e.target.value;
        const numericValue = input.replace(/\D/g, "");
        setNumber(numericValue);
    };

    const handleOptionChange = (e) => {
        setSelectedOption(e.target.value);
    };

    function handlePhoto(e) {
        let dataStatus = FormatChecker(e.target.files[0]);
        setPhotoStatus(dataStatus);
        if (!dataStatus) {
            setPhoto(e.target.files[0]);
            const objectUrl = URL.createObjectURL(e.target.files[0]);
            setPreviews(prev => ({ ...prev, photo: objectUrl }));
        } else {
            message.error("please upload in the given format");
        }
    }
    const handleName = (e) => {
        const newValue = e.target.value;
        const alphabetOnlyValue = newValue.replace(/[^A-Za-z ]/g, "");
        setVisitorName(alphabetOnlyValue);
    };
    const handleCity = (e) => {
        const newValue = e.target.value;
        const alphabetOnlyValue = newValue.replace(/[^A-Za-z ]/g, "");
        setCity(alphabetOnlyValue);
    };
    const handleState = (e) => {
        const newValue = e.target.value;
        const alphabetOnlyValue = newValue.replace(/[^A-Za-z ]/g, "");
        setState(alphabetOnlyValue);
    };
    const handleCountry = (e) => {
        const newValue = e.target.value;
        const alphabetOnlyValue = newValue.replace(/[^A-Za-z ]/g, "");
        setCountry(alphabetOnlyValue);
    };

    const handleCommunicationAddress = (e) => {
        const checked = e.target.checked;
        setSameAddress(checked);
        if (checked) {
            setCommAddress(streetAddress);
            setCommCity(city);
            setCommPincode(postalCode);
            setCommState(state);
        } else {
            setCommAddress("");
            setCommCity("");
            setCommPincode("");
            setCommState("");
        }
    };

    const handleNumberSubmit = (e) => {
        e.preventDefault();
        setIsOtpStep(true);
    };

    const handleOtpSubmit = (e) => {
        e.preventDefault();
        setIsRotated(true);
    };

    const handlePostalCode = (e) => {
        const input = e.target.value;
        const numericValue = input.replace(/\D/g, "");
        setPostalCode(numericValue);
    };

    function handleIDFront(e) {
        let dataStatus = FormatChecker(e.target.files[0]);
        setIdFrontStatus(dataStatus);
        if (!dataStatus) {
            setIDProofFront(e.target.files[0]);
            const objectUrl = URL.createObjectURL(e.target.files[0]);
            setPreviews(prev => ({ ...prev, idProofFront: objectUrl }));
        } else {
            message.error("please upload in the given format");
        }
    }

    function handleIDBack(e) {
        let dataStatus = FormatChecker(e.target.files[0]);
        setIdBackStatus(dataStatus);
        if (!dataStatus) {
            setIDProofBack(e.target.files[0]);
            const objectUrl = URL.createObjectURL(e.target.files[0]);
            setPreviews(prev => ({ ...prev, idProofBack: objectUrl }));
        } else {
            message.error("please upload in the given format");
        }
    }

    const renderPreview = (name, existingFile, folder) => {
        const preview = previews[name];
        if (!preview && !existingFile) return null;

        const fileUrl = preview ? preview : `${process.env.REACT_APP_IMAGE_URL || 'https://cdnjascrm.samaksh.in/media'}/${folder}/${existingFile}`;

        // Check if it's a PDF
        let isPDF = false;
        if (preview && name === 'photo' && photo instanceof File) {
            isPDF = photo.type === 'application/pdf';
        } else if (preview && name === 'idProofFront' && idProofFront instanceof File) {
            isPDF = idProofFront.type === 'application/pdf';
        } else if (preview && name === 'idProofBack' && idProofBack instanceof File) {
            isPDF = idProofBack.type === 'application/pdf';
        } else if (typeof fileUrl === 'string') {
            isPDF = fileUrl.toLowerCase().endsWith('.pdf') || fileUrl.startsWith('data:application/pdf');
        }

        return (
            <div className="mt-2">
                <a href={fileUrl} target="_blank" rel="noopener noreferrer" className="text-decoration-none">
                    {isPDF ? (
                        <div className="p-2 border rounded bg-light text-dark d-inline-flex align-items-center" style={{ cursor: 'pointer' }}>
                            <span className="me-2">📄</span>
                            <span>PDF Preview (Click to open)</span>
                        </div>
                    ) : (
                        <img
                            src={fileUrl}
                            alt={`${name} preview`}
                            className="img-thumbnail"
                            style={{ maxHeight: '150px', cursor: 'pointer' }}
                        />
                    )}
                </a>
            </div>
        );
    }
    const handleEmailChange = (e) => {
        const value = e.target.value;
        setEmail(value);

        const emailPattern = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;

        if (!emailPattern.test(value)) {
            setEmailError("Invalid email format");
        } else {
            setEmailError("");
        }
    };

    const handleCheckNoIsPresentOrNot = () => {
        setReload(true)

        axios
            .post(
                `${process.env.REACT_APP_API_END_POINT}/check-no-is-present-in-buyer`,
                { number }
            )
            .then((resData) => {
                setReload(false)

                if (!resData.data.status) {
                    message.error(resData.data.message);
                } else {
                    setDataPresent(resData.data.data);
                    console.log("resData.data.data", resData.data.data);
                    setIsRotated(true);
                    setVisitorName(resData.data.data.visitor_name);
                    setYourCompany(resData.data.data.company_name);
                    setGst_number(resData.data.data.gst_number);
                    setStreetAddress(resData.data.data.street_address);
                    setNumber(resData.data.data.mobile_number);
                    setEmail(resData.data.data.email);
                    setDesignation(resData.data.data.designation);
                    setCountry(resData.data.data?.country)
                    setallreadyPhoto(resData.data.data?.photo);
                    setallreadyIDProofBack(resData.data.data?.id_proof_back);
                    setallreadyIDProofFront(resData.data.data?.id_proof_front);
                    setInvited_exhibitor_id(resData.data.data?.invited_exhibitor_id || "");

                    // Travel Fields
                    setArrivalFrom(resData.data.data.arrivalFrom || "");
                    setArrivalDate(resData.data.data.arrivalDate || "");
                    setArrivalTime(resData.data.data.arrivalTime || "");
                    setArrivalMode(resData.data.data.arrivalMode || "");
                    setModeDetails(resData.data.data.modeDetails || "");
                    const loadedStayDuration2 = resData.data.data.stayDuration || "";
                    setStayDuration(loadedStayDuration2);
                    if (["2nd July", "3rd July", "4th July", "5th July"].includes(loadedStayDuration2)) {
                        setStayOption("1");
                    } else if (["2nd - 4th July", "3rd - 5th July", "4th - 6th July", "5th - 6th July"].includes(loadedStayDuration2)) {
                        setStayOption("2");
                    } else {
                        setStayOption("");
                    }
                    setHotelCheckInDate(resData.data.data.hotelCheckInDate || "");
                    setHotelCheckOutDate(resData.data.data.hotelCheckOutDate || "");
                    setRequiresCab(resData.data.data.requiresCab || "");
                    setDepartureDate(resData.data.data.departureDate || "");
                    setDepartureTime(resData.data.data.departureTime || "");
                    setDepartureMode(resData.data.data.departureMode || "");
                    setAllreadyTicket(resData.data.data.upload_ticket || null);
                }
            });
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        if (!invited_exhibitor_id) {
            return message.error('Invited By company is required.');
        }

        if (exhibitor_one && exhibitor_two && exhibitor_one === exhibitor_two) {
            return message.error('Exhibitor 1 and Exhibitor 2 cannot be the same.');
        }

        if (arrivalMode && arrivalDate) {
            if (arrivalDate > "2026-07-05" || arrivalDate < "2026-06-30") {
                return message.error('Please select date between 30th June, 2026 - 5th July, 2026');
            }
        }

        if (requiresCab === 'Yes' && departureDate) {
            if (departureDate > "2026-07-06" || departureDate < "2026-06-30") {
                return message.error('Please select date between 30th June, 2026 - 6th July, 2026');
            }
        }

        setIsLoading(true);

        const data = new FormData();
        data.append("visitor_name", visitorName || "");
        data.append("mobile_number", number || "");
        data.append("arrivalFrom", arrivalFrom || "");
        data.append("arrivalDate", arrivalDate || "");
        data.append("arrivalTime", arrivalTime || "");
        data.append("arrivalMode", arrivalMode || "");
        data.append("modeDetails", arrivalMode === 'Self' ? '' : (modeDetails || ""));
        data.append("hotelCheckInDate", hotelCheckInDate || "");
        data.append("hotelCheckOutDate", hotelCheckOutDate || "");
        data.append("requiresCab", requiresCab || "");
        data.append("departureDate", departureDate || "");
        data.append("departureTime", departureTime || "");
        data.append("departureMode", departureMode || "");
        data.append("stayDuration", stayDuration || "");
        
        if (arrivalMode !== 'Self' && ticket instanceof File) {
            data.append("upload_ticket", ticket);
        }
        if (photo instanceof File) {
            data.append("photo", photo);
        }
        if (idProofFront instanceof File) {
            data.append("id_proof_front", idProofFront);
        }
        if (idProofBack instanceof File) {
            data.append("id_proof_back", idProofBack);
        }

        data.append("_id", buyer_edit?._id || "");
        data.append("company_name", companyName || "");
        data.append("email", email || "");
        data.append("gst_number", gst_number || "");
        data.append("street_address", streetAddress || "");
        data.append("city", city || "");
        data.append("state", state || "");
        data.append("postal_code", postalCode || "");
        data.append("country", country || "");
        data.append("exhibitor_one", exhibitor_one || "");
        data.append("exhibitor_two", exhibitor_two || "");
        data.append("invited_exhibitor_id", invited_exhibitor_id || "");
        data.append("commAddress", commAddress || "");
        data.append("commCity", commCity || "");
        data.append("commPincode", commPincode || "");
        data.append("commState", commState || "");
        data.append("sameAddress", sameAddress !== undefined ? sameAddress : "");
        data.append("designation", designation || "");
        axios
            .post(
                `${process.env.REACT_APP_API_END_POINT}/edit-buyer-details`,
                data,
                {
                    headers: {
                        barcode: buyer_edit?.barcode || "",
                        token: localStorage.getItem("jff_token"),
                    },
                }
            )
            .then((resData) => {
                setIsLoading(false);
                message.success("Changes Saved");
                setIsRotated(false);
                navigate(`/superadmin/vip-guest`)
            })
            .catch((err) => {
                setIsLoading(false);
                const errMsg = err?.response?.data?.error || err?.response?.data?.message || err?.message || "An error occurred. Please try again.";
                console.error("Submission error details:", err);
                message.error(errMsg);
            });
    };

    const regex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
    function checkRegex(input) {
        return regex.test(input);
    }

    function convertToUpperCase(input) {
        return input.replace(/[a-z]/gi, (char) => char.toUpperCase());
    }

    const handleGstNumberChange = (e) => {
        setGst_number(convertToUpperCase(e.target.value));
        const value = e.target.value;
        if (checkRegex(value)) {
            console.log("asdasdasd", e.target.value);
            setShowError("");
        } else {
            setShowError("Provide Valid GSTIN");
        }
    };




    useEffect(() => {

        if (gst_number?.length === 15 && checkRegex(gst_number)) {
            // setReloadShow(true);
            // ;

            axios
                .get(
                    `${process.env.REACT_APP_API_END_POINT}/check-gst-validation/${gst_number}`
                )
                .then((resData) => {
                    // setReloadShow(false);
                    // console.log(
                    //   "hello i am here to see the test daeeed",
                    //   resData.data.message,
                    //   resData.data.data.lgnm,
                    //   resData.data.data.pradr.adr
                    // );
                    // if (resData.data.message === "GSTIN  found.") {
                    console.log("gst find or not", resData.data);
                    if (resData.data.flag === false) {
                        setShowError(resData.data.message);
                        return;
                    }
                    setShowError("");
                    setCompanyName(resData.data.company);
                    setStreetAddress(resData.data.address);
                    setCity(resData.data.city);
                    // }
                }).catch((err) => {
                    console.log("gst fetch validation ")
                    setShowError("Facing Problem While Fetching")
                })
        }
    }, [gst_number]);

    useEffect(() => {
        let checkIn = "";
        let checkOut = "";

        if (stayDuration) {
            if (stayOption === "1") {
                if (stayDuration === "2nd July") {
                    checkIn = "2026-07-02";
                    checkOut = "2026-07-03";
                } else if (stayDuration === "3rd July") {
                    checkIn = "2026-07-03";
                    checkOut = "2026-07-04";
                } else if (stayDuration === "4th July") {
                    checkIn = "2026-07-04";
                    checkOut = "2026-07-05";
                } else if (stayDuration === "5th July") {
                    checkIn = "2026-07-05";
                    checkOut = "2026-07-06";
                }
            } else if (stayOption === "2") {
                if (stayDuration === "2nd - 4th July") {
                    checkIn = "2026-07-02";
                    checkOut = "2026-07-04";
                } else if (stayDuration === "3rd - 5th July") {
                    checkIn = "2026-07-03";
                    checkOut = "2026-07-05";
                } else if (stayDuration === "4th - 6th July") {
                    checkIn = "2026-07-04";
                    checkOut = "2026-07-06";
                } else if (stayDuration === "5th - 6th July") {
                    checkIn = "2026-07-05";
                    checkOut = "2026-07-06";
                }
            }
        }

        setHotelCheckInDate(checkIn);
        setHotelCheckOutDate(checkOut);
    }, [stayDuration, stayOption]);



    return (
        <>
            <Header />
            {showData && showData.vip_additional_info === "inactive" ? (
                <div className="d-flex justify-content-center align-items-center vh-100">
                    <div className="alert alert-warning text-center" role="alert">
                        <strong>Form is suspended</strong>
                    </div>
                </div>
            ) : (
                <div style={{ backgroundColor: '#f4f6f9', minHeight: '100vh', paddingBottom: '50px' }}>
                    <Container fluid className='py-4 px-5'>
                        <Row>
                            <Col lg={8} className="text-dark bg-white p-4 shadow-sm" style={{ borderRadius: '8px' }}>
                                <div className="mb-4 mt-4">
                                    <p className="fw-bold mb-1 text-dark">Note** Application will not be applicable for Jaipur Residents</p>
                                    <p className="fw-bold text-dark">Note** The registration confirmation is subject to the approval by the organising committee</p>
                                </div>

                                <form onSubmit={handleSubmit} className="px-2">
                                    <div className="row">
                                            <>
                                                            <div className="col-12 mb-3 mt-2">
                                                                <h5 className="text-dark fw-bold">Company / Personal Details</h5>
                                                            </div>
                                                            <div className="form-group col-lg-6 col-md-6">
                                                                <label className="fw-bold">
                                                                    Your Name
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    className="form-control my-2 border-warning"
                                                                    placeholder="Enter Name"
                                                                    value={visitorName}
                                                                    maxLength={100}
                                                                    onChange={(e) => {
                                                                        handleName(e);
                                                                    }}
                                                                />
                                                            </div>
                                                            <div className="form-group col-lg-6 col-md-6">
                                                                <label className="fw-bold">
                                                                    Mobile
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    className="form-control my-2 border-warning"
                                                                    placeholder="Enter Mobile"
                                                                    value={number}
                                                                    maxLength={10}
                                                                    onChange={handleMobileNoChange}
                                                                />
                                                            </div>
                                                            <div className="form-group col-lg-6 col-md-6">
                                                                <label className="fw-bold">Email</label>
                                                                <input type="email" className="form-control my-2 border-warning" placeholder="Enter Email" value={email} onChange={(e) => setEmail(e.target.value)} />
                                                            </div>
                                                            {localStorage.getItem('role') !== 'subadmin' && (
                                                                <>
                                                                    <div className="form-group col-lg-6 col-md-6">
                                                                        <label className="fw-bold">GST Number</label>
                                                                        <input type="text" className="form-control my-2 border-warning" placeholder="Enter GST Number" value={gst_number} maxLength={15} onChange={(e) => handleGstNumberChange(e)} />
                                                                        {showError && <p className="text-danger">{showError}</p>}
                                                                    </div>
                                                                    <div className="form-group col-lg-6 col-md-6">
                                                                        <label className="fw-bold">Company</label>
                                                                        <input type="text" className="form-control my-2 border-warning" placeholder="Enter Company" value={companyName} onChange={(e) => setCompanyName(e.target.value)} />
                                                                    </div>
                                                                    <div className="form-group col-lg-6 col-md-6">
                                                                        <label className="fw-bold">Country</label>
                                                                        <input type="text" className="form-control my-2 border-warning" placeholder="Enter Country" value={country} onChange={(e) => setCountry(e.target.value)} />
                                                                    </div>
                                                                    <div className="form-group col-lg-6 col-md-6">
                                                                        <label className="fw-bold">Address</label>
                                                                        <input type="text" className="form-control my-2 border-warning" placeholder="Enter Address" value={streetAddress} onChange={(e) => setStreetAddress(e.target.value)} />
                                                                    </div>
                                                                    <div className="form-group col-lg-6 col-md-6">
                                                                        <label className="fw-bold">City</label>
                                                                        <input type="text" className="form-control my-2 border-warning" placeholder="Enter City" value={city} onChange={(e) => setCity(e.target.value)} />
                                                                    </div>
                                                                    <div className="form-group col-lg-6 col-md-6">
                                                                        <label className="fw-bold">Pincode</label>
                                                                        <input type="text" className="form-control my-2 border-warning" placeholder="Enter Pincode" value={postalCode} onChange={(e) => setPostalCode(e.target.value)} />
                                                                    </div>
                                                                    <div className="form-group col-lg-6 col-md-6">
                                                                        <label className="fw-bold">State</label>
                                                                        <input type="text" className="form-control my-2 border-warning" placeholder="Enter State" value={state} onChange={(e) => setState(e.target.value)} />
                                                                    </div>
                                                                </>
                                                            )}
                                                            <div className="form-group col-lg-6 col-md-6">
                                                                <label className="fw-bold">
                                                                    Designation
                                                                </label>
                                                                <Select
                                                                    className="my-2"
                                                                    options={designationArray.map((data) => ({
                                                                        value: data,
                                                                        label: data,
                                                                    }))}
                                                                    value={
                                                                        designation
                                                                            ? { value: designation, label: designation }
                                                                            : null
                                                                    }
                                                                    onChange={(selectedOption) =>
                                                                        setDesignation(
                                                                            selectedOption ? selectedOption.value : null
                                                                        )
                                                                    }
                                                                    isSearchable
                                                                    placeholder="Select designation"
                                                                />
                                                            </div>
                                                            <div className="col-12 mt-4">
                                                                <h5 className="text-dark fw-bold mb-3">Select Exhibitor</h5>
                                                            </div>
                                                            <div className="form-group col-lg-6 col-md-6">
                                                                <label className="fw-bold">Invited By <font color="#FF0000">*</font></label>
                                                                <Select
                                                                    options={exhibitorList}
                                                                    value={exhibitorList.find(opt => opt.value === invited_exhibitor_id) || null}
                                                                    onChange={(selectedOption) => {
                                                                        setInvited_exhibitor_id(selectedOption ? selectedOption.value : '')
                                                                    }}
                                                                    isSearchable
                                                                    placeholder="Select Invited By Company"
                                                                />
                                                            </div>
                                                            <div className="form-group col-lg-6 col-md-6">
                                                                <label className="fw-bold">Exhibitor 1</label>
                                                                <Select
                                                                    options={exhibitorList}
                                                                    value={exhibitorList.find(opt => opt.value === exhibitor_one) || null}
                                                                    onChange={(selectedOption) => {
                                                                        setExhibitor_one(selectedOption ? selectedOption.value : '')
                                                                    }}
                                                                    isSearchable
                                                                    placeholder="Select Exhibitor 1"
                                                                />
                                                            </div>
                                                            <div className="form-group col-lg-6 col-md-6">
                                                                <label className="fw-bold">Exhibitor 2</label>
                                                                <Select
                                                                    options={exhibitorList}
                                                                    value={exhibitorList.find(opt => opt.value === exhibitor_two) || null}
                                                                    onChange={(selectedOption) => {
                                                                        setExhibitor_two(selectedOption ? selectedOption.value : '')
                                                                    }}
                                                                    isSearchable
                                                                    placeholder="Select Exhibitor 2"
                                                                />
                                                            </div>

                                                            <div className="col-12 mt-4">
                                                                <h5 className="text-dark fw-bold mb-3">Postal Address (For sending Show Badges)</h5>
                                                                <div className="form-check mb-2">
                                                                    <input
                                                                        type="checkbox"
                                                                        className="form-check-input"
                                                                        id="sameAsGstAddress"
                                                                        checked={sameAddress}
                                                                        onChange={handleCommunicationAddress}
                                                                    />
                                                                    <label className="form-check-label text-dark" htmlFor="sameAsGstAddress">
                                                                        Same as GST address
                                                                    </label>
                                                                </div>
                                                            </div>

                                                            <div className="form-group col-lg-6 col-md-6">
                                                                <label className="fw-bold">Address</label>
                                                                <input
                                                                    type="text"
                                                                    className="form-control my-2 border-warning"
                                                                    placeholder="Enter Address"
                                                                    value={commAddress}
                                                                    onChange={(e) => setCommAddress(e.target.value)}
                                                                />
                                                            </div>
                                                            <div className="form-group col-lg-6 col-md-6">
                                                                <label className="fw-bold">City</label>
                                                                <input
                                                                    type="text"
                                                                    className="form-control my-2 border-warning"
                                                                    placeholder="Enter City"
                                                                    value={commCity}
                                                                    onChange={(e) => setCommCity(e.target.value)}
                                                                />
                                                            </div>
                                                            <div className="form-group col-lg-6 col-md-6">
                                                                <label className="fw-bold">Pincode</label>
                                                                <input
                                                                    type="text"
                                                                    className="form-control my-2 border-warning"
                                                                    placeholder="Enter Pincode"
                                                                    value={commPincode}
                                                                    onChange={(e) => setCommPincode(e.target.value)}
                                                                />
                                                            </div>
                                                            <div className="form-group col-lg-6 col-md-6">
                                                                <label className="fw-bold">State</label>
                                                                <input
                                                                    type="text"
                                                                    className="form-control my-2 border-warning"
                                                                    placeholder="Enter State"
                                                                    value={commState}
                                                                    onChange={(e) => setCommState(e.target.value)}
                                                                />
                                                            </div>
                                            </>
                                            <>
                                                            <div className="col-12 mb-3 mt-4">
                                                                <h5 className="text-dark fw-bold">Upload ID / Photo Documents</h5>
                                                            </div>
                                                            <div className="col-lg-6 col-md-6">
                                                                <div className="form-group">
                                                                    <label className="fw-bold">
                                                                        Upload Photo{" "}

                                                                        {photoStatus && (
                                                                            <span className="photo-error">
                                                                                Only supported (JPG/JPEG/PNG)
                                                                            </span>
                                                                        )}
                                                                    </label>
                                                                    <input
                                                                        type="file"
                                                                        onChange={handlePhoto}
                                                                        className="form-control my-2 border-warning"
                                                                        accept=".jpg, .jpeg, .png"
                                                                    />
                                                                    {renderPreview('photo', allreadyphoto, 'photo')}
                                                                </div>
                                                            </div>

                                                            <div className="col-lg-6 col-md-6 ">
                                                                <div className="form-group">
                                                                    <label className="fw-bold">
                                                                        ID Proof(front){" "}

                                                                        {idFrontStatus && (
                                                                            <span className="photo-error">
                                                                                Only supported (JPG/JPEG/PNG)
                                                                            </span>
                                                                        )}
                                                                    </label>
                                                                    <input
                                                                        type="file"
                                                                        onChange={handleIDFront}
                                                                        className="form-control my-2 border-warning"
                                                                        accept=".jpg, .jpeg, .png"
                                                                    />
                                                                    {renderPreview('idProofFront', allreadyidProofFront, 'id_proof')}
                                                                </div>
                                                            </div>

                                                            <div className="col-lg-6 col-md-6">
                                                                <div className="form-group">
                                                                    <label className="fw-bold">
                                                                        ID Proof(back){" "}

                                                                        {idBackStatus && (
                                                                            <span className="photo-error">
                                                                                Only supported (JPG/JPEG/PNG)
                                                                            </span>
                                                                        )}
                                                                    </label>
                                                                    <input
                                                                        type="file"
                                                                        onChange={handleIDBack}
                                                                        className="form-control my-2 border-warning"
                                                                        accept=".jpg, .jpeg, .png"
                                                                    />
                                                                    {renderPreview('idProofBack', allreadyidProofBack, 'id_proof')}
                                                                </div>
                                                            </div>
                                            </>
                                            <>
                                                <div className="col-12 mb-3 mt-4">
                                                    <h5 className="text-dark fw-bold">Travel & Accommodation Details</h5>
                                                </div>
                                                <div className="col-12 mb-3 mt-2">
                                                    <h5 className="fw-bold">Arrival Travel Information</h5>
                                                </div>

                                                <div className="form-group col-lg-6 col-md-6 mb-3">
                                                    <label className="fw-bold">Arrival Mode (Flight / Train / Self)</label>
                                                    <select
                                                        name="arrivalMode"
                                                        value={arrivalMode}
                                                        onChange={(e) => {
                                                            const val = e.target.value;
                                                            setArrivalMode(val);
                                                            if (val === 'Self') {
                                                                setModeDetails("");
                                                                setTicket(null);
                                                                setAllreadyTicket("");
                                                                setPreviews(prev => ({ ...prev, ticket: null }));
                                                            }
                                                        }}
                                                        className="form-select border-warning my-2"
                                                    >
                                                        <option value="">Select Mode</option>
                                                        <option value="Flight">Flight</option>
                                                        <option value="Train">Train</option>
                                                        <option value="Self">Self</option>
                                                     </select>
                                                </div>

                                                {arrivalMode && (
                                                    <div className="form-group col-lg-6 col-md-6 mb-3">
                                                        <label className="fw-bold">Arrival From - City</label>
                                                        <input
                                                            type="text"
                                                            name="arrivalFrom"
                                                            placeholder="Enter Arrival City"
                                                            value={arrivalFrom}
                                                            onChange={(e) => setArrivalFrom(e.target.value)}
                                                            className="form-control border-warning my-2"
                                                        />
                                                    </div>
                                                )}

                                                {arrivalMode && (
                                                    <>
                                                        <div className="form-group col-lg-6 col-md-6 mb-3">
                                                            <label className="fw-bold">Arrival Date</label>
                                                            <input
                                                                type="date"
                                                                name="arrivalDate"
                                                                value={arrivalDate}
                                                                onChange={(e) => setArrivalDate(e.target.value)}
                                                                className="form-control border-warning my-2"
                                                                min="2026-06-30"
                                                                max="2026-07-05"
                                                            />
                                                        </div>
                                                        <div className="form-group col-lg-6 col-md-6 mb-3">
                                                            <label className="fw-bold">Arrival Time</label>
                                                            <input
                                                                type="time"
                                                                name="arrivalTime"
                                                                value={arrivalTime}
                                                                onChange={(e) => setArrivalTime(e.target.value)}
                                                                className="form-control border-warning my-2"
                                                            />
                                                        </div>
                                                    </>
                                                )}

                                                {arrivalMode && arrivalMode !== 'Self' && (
                                                    <>
                                                        <div className="form-group col-lg-6 col-md-6 mb-3">
                                                            <label className="fw-bold">Mode Details (Flight No. / Train No.)</label>
                                                            <input
                                                                type="text"
                                                                name="modeDetails"
                                                                placeholder="Enter Mode Details"
                                                                value={modeDetails}
                                                                onChange={(e) => setModeDetails(e.target.value)}
                                                                className="form-control border-warning my-2"
                                                            />
                                                        </div>

                                                        <div className="form-group col-lg-6 col-md-6 mb-3">
                                                            <label className="fw-bold">Upload Ticket</label>
                                                            <input
                                                                type="file"
                                                                name="ticket"
                                                                accept=".png, .jpg, .jpeg, .pdf"
                                                                onChange={(e) => {
                                                                    setTicket(e.target.files[0]);
                                                                    if(e.target.files[0]) {
                                                                        const objectUrl = URL.createObjectURL(e.target.files[0]);
                                                                        setPreviews(prev => ({ ...prev, ticket: objectUrl }));
                                                                    }
                                                                }}
                                                                className="form-control border-warning my-2"
                                                            />
                                                            {renderPreview('ticket', allreadyticket, 'tickets')}
                                                        </div>
                                                    </>
                                                )}

                                                <div className="form-group col-lg-12 col-md-12 mb-3">
                                                    <label className="fw-bold d-block">Stay Duration</label>
                                                    <div className="d-flex my-2">
                                                        <div className="form-check me-4">
                                                            <input
                                                                className="form-check-input"
                                                                type="radio"
                                                                name="stayOption"
                                                                id="stay1"
                                                                value="1"
                                                                checked={stayOption === "1"}
                                                                onChange={(e) => {
                                                                    setStayOption(e.target.value);
                                                                    setStayDuration("");
                                                                }}
                                                            />
                                                            <label className="form-check-label" htmlFor="stay1">
                                                                1 Night
                                                            </label>
                                                        </div>
                                                        <div className="form-check">
                                                            <input
                                                                className="form-check-input"
                                                                type="radio"
                                                                name="stayOption"
                                                                id="stay2"
                                                                value="2"
                                                                checked={stayOption === "2"}
                                                                onChange={(e) => {
                                                                    setStayOption(e.target.value);
                                                                    setStayDuration("");
                                                                }}
                                                            />
                                                            <label className="form-check-label" htmlFor="stay2">
                                                                2 Nights
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>

                                                {stayOption && (
                                                    <div className="form-group col-lg-6 col-md-6 mb-3">
                                                        <label className="fw-bold">Select Date</label>
                                                        <select
                                                            name="stayDuration"
                                                            value={stayDuration}
                                                            onChange={(e) => setStayDuration(e.target.value)}
                                                            className="form-select border-warning my-2"
                                                        >
                                                            <option value="">Select Date</option>
                                                            {(stayOption === "1" ? ["2nd July", "3rd July", "4th July", "5th July"] : ["2nd - 4th July", "3rd - 5th July", "4th - 6th July", "5th - 6th July"]).map(
                                                                (option, index) => (
                                                                    <option key={index} value={option}>{option}</option>
                                                                )
                                                            )}
                                                        </select>
                                                    </div>
                                                )}

                                                <div className="col-12 mb-3 mt-4">
                                                    <h5 className="fw-bold">Departure Travel Information (If requires Cab for logistics)</h5>
                                                </div>

                                                <div className="form-group col-lg-12 col-md-12 mb-3">
                                                    <label className="fw-bold d-block">Cab Required?</label>
                                                    <div className="d-flex my-2">
                                                        <div className="form-check me-4">
                                                            <input
                                                                className="form-check-input"
                                                                type="radio"
                                                                name="cabRequired"
                                                                id="cabYes"
                                                                value="Yes"
                                                                checked={requiresCab === 'Yes'}
                                                                onChange={(e) => setRequiresCab(e.target.value)}
                                                            />
                                                            <label className="form-check-label" htmlFor="cabYes">Yes</label>
                                                        </div>
                                                        <div className="form-check">
                                                            <input
                                                                className="form-check-input"
                                                                type="radio"
                                                                name="cabRequired"
                                                                id="cabNo"
                                                                value="No"
                                                                checked={requiresCab === 'No'}
                                                                onChange={(e) => setRequiresCab(e.target.value)}
                                                            />
                                                            <label className="form-check-label" htmlFor="cabNo">No</label>
                                                        </div>
                                                    </div>
                                                </div>

                                                {requiresCab === 'Yes' && (
                                                    <>
                                                        <div className="form-group col-lg-6 col-md-6 mb-3">
                                                            <label className="fw-bold">Departure Date</label>
                                                            <input
                                                                type="date"
                                                                name="departureDate"
                                                                value={departureDate}
                                                                onChange={(e) => setDepartureDate(e.target.value)}
                                                                className="form-control border-warning my-2"
                                                                min="2026-06-30"
                                                                max="2026-07-06"
                                                            />
                                                        </div>
                                                        <div className="form-group col-lg-6 col-md-6 mb-3">
                                                            <label className="fw-bold">Departure Time from Hotel</label>
                                                            <input
                                                                type="time"
                                                                name="departureTime"
                                                                value={departureTime}
                                                                onChange={(e) => setDepartureTime(e.target.value)}
                                                                className="form-control border-warning my-2"
                                                            />
                                                        </div>
                                                        <div className="form-group col-lg-6 col-md-6 mb-3">
                                                            <label className="fw-bold">Departure Mode</label>
                                                            <select
                                                                name="departureMode"
                                                                value={departureMode}
                                                                onChange={(e) => setDepartureMode(e.target.value)}
                                                                className="form-select border-warning my-2"
                                                            >
                                                                <option value="">Select Mode</option>
                                                                <option value="Flight">Flight</option>
                                                                <option value="Train">Train</option>
                                                                <option value="Self">Self</option>
                                                            </select>
                                                        </div>
                                                    </>
                                                )}
                                            </>

                                                            <div className="form-submit d-flex justify-content-end mt-4 col-12">
                                                                <Button
                                                                    type="submit"
                                                                    variant="primary"
                                                                    disabled={isLoading}
                                                                    style={{ backgroundColor: '#d0a33b', border: 'none' }}
                                                                    className="px-4"
                                                                >
                                                                    {isLoading ? <Spinner animation="border" size="sm" /> : "Submit"}
                                                                </Button>
                                                            </div>
                                    </div>
                                </form>
                            </Col>
                            <Col lg={4} className="mt-4 mt-lg-0 px-2 d-flex flex-column gap-3">
                                {['At a Glance / History / Tourist Spots / Entertainment', 'Official Hotels / Air Info / Rail Info / Road Info', 'Restaurant Info / Venue'].map((text, idx) => (
                                    <div key={idx} className="p-4 bg-white d-flex align-items-center justify-content-center text-center shadow-sm" style={{ border: '1px solid #e0e0e0', minHeight: '100px', borderRadius: '8px' }}>
                                        <h5 className="m-0" style={{ color: '#333', fontWeight: '400', fontSize: '1.2rem' }}>{text}</h5>
                                    </div>
                                ))}
                            </Col>
                        </Row>
                    </Container>
                    <div className="mt-4">
                        <Footer />
                    </div>
                </div>
            )}
        </>
    );
};

export default EditBuyerForm;
